<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.params.type==='10'">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.params.type==='1'">财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称"
                        prop="customerid">
            <remote-select style="width: 100%;"
                           v-model="search.customerid"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="customerLabel"
                           value-key="id"
                           placeholder="请输入客户名称/编号搜索"
                           :query-request="customerRemoteMethod"
                           @change="search.projectid=null"
                           :find-request="getCustomerInfoRemote">
            </remote-select>

          </el-form-item>
          <el-form-item label="项目名称"
                        prop="projectid">
            <remote-select style="width: 100%;"
                           v-model="search.projectid"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="customerLabel"
                           value-key="id"
                           placeholder="请输入项目名称/编号搜索"
                           :query-request="projectRemoteMethod"
                           :find-request="getProjectInfoRemote">
            </remote-select>
          </el-form-item>
          <el-form-item label="回款状态"
                        prop="received_payment_status">
            <el-select v-model="search.received_payment_status"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option
                v-for="item in options.received_payment_status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="BO审批"
                        prop="bu_approver">
            <remote-select style="width: 100%;"
                           v-model="search.bu_approver"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="回款日期"
                        prop="received_payment_time">
            <el-date-picker v-model="search.received_payment_time"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="申请描述"
                        prop="desc">
            <el-input style="width: 100%;"
                      v-model="search.desc"
                      clearable
                      placeholder="请输入申请描述关键字搜索">
            </el-input>
          </el-form-item>
          <el-form-item label="开票金额">
            <el-col :span="11">
              <el-form-item prop="total_amount_min">
                <el-input v-model="search.total_amount_min"
                          clearable
                          placeholder="请输入含税金额起始值" />
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item prop="total_amount_max">
                <el-input v-model="search.total_amount_max"
                          clearable
                          placeholder="请输入含税金额结束值" />
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="发起人"
                        prop="initiator">
            <remote-select style="width: 100%;"
                           v-model="search.initiator"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   size="small"
                   @click="onExportSearch()">按搜索结果导出
        </el-button>
        <el-button type="primary"
                   size="small"
                   @click="openReceivedSummaryDialog">按搜索结果汇总
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @sort-change="sortChange">
        <el-table-column prop="id"
                         label="ID"
                         sortable="custom"
                         min-width="90"></el-table-column>
        <el-table-column prop="desc"
                         label="申请描述"
                         min-width="120">
          <template slot-scope="scope">
            <a @click="openDetail(scope.row.id)" href="javascript:void(0);">
              {{scope.row.desc}}
            </a>
          </template>
        </el-table-column>
        <el-table-column label="客户编号"
                         width="190">
          <!--客户名/编号-->
          <template slot-scope="scope">
            {{scope.row.customer_name}}/{{scope.row.customer_number}}
          </template>
        </el-table-column>
        <el-table-column prop="company_name"
                         label="公司名称"
                         min-width="90"></el-table-column>
        <el-table-column prop="received_payment_status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.received_payment_status"
                  v-if="scope.row.received_payment_status === item.value"
                >{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total"
                         label="含税开票金额"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="scope.row.currency_type === item.value"
            >{{item.symbol}}</span>
            {{scope.row.total | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="received_amount"
                         label="已回款金额"
                         min-width="120">
          <template slot-scope="scope">
              <span v-for="item in options.currency_type"
                    v-if="scope.row.currency_type === item.value"
              >{{item.symbol}}</span>
            {{scope.row.received_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column label="未回款金额"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="scope.row.currency_type === item.value"
            >{{item.symbol}}</span>
            {{scope.row.unreceived_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="initiator_name"
                         label="发起人"
                         min-width="120"></el-table-column>
        <el-table-column prop="bu_name"
                         label="BO审批"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                        label="创建时间"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="received_payment_time"
                         label="回款日期"
                         sortable="custom"
                         min-width="120">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="230">
          <template slot-scope="scope">
            <router-link
              :to="`/invoice-apply/received-payment-detail/${scope.row.id}/type/${$route.params.type}?currency_type=${scope.row.currency_type}`">
              <el-button size="mini">查看
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <received-summary-dialog :visible="summaryVisible"
                             :receivedSummary="receivedSummary"
                             :title="title"
                             @closeDialog="summaryVisible=false"></received-summary-dialog>
  </div>
</template>

<script>
import { searchRules } from '../invoice-apply.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, {removeEmptyParams} from '@core/mixins/table'
import selectRemote from '@core/mixins/selectRemote'
import OperationButtons from '@/views/invoice-apply/components/OperationButtons'
import ReceivedSummaryDialog from '@/views/invoice-apply/components/ReceivedSummaryDialog'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  components: {
    OperationButtons,
    ReceivedSummaryDialog,
  },
  data () {
    return {
      searchRules,
      search: {
        received_payment_status: null,
        customerid: null,
        projectid: null,
        bu_approver: null,
        initiator: null,
        created_at: [],
        received_payment_time: [],
        sort_by_received_payment_time: null,
        sort_by_id: null,
        desc: null,
        total_amount_min: null,
        total_amount_max: null,
      },
      searchFieldType: {
        received_payment_status: Number,
        customerid: String,
        projectid: String,
        bu_approver: Number,
        initiator: Number,
      },
      selectLoading: false,
      customerItems: [],
      projectItems: [],
      adminuserItems: [],
      exportHeader: [
        {
          key: 'id',
          text: '开票申请ID',
        },
        {
          key: 'subject_name',
          text: '开票主体',
        },
        {
          key: 'customer_number',
          text: '客户编号',
        },
        {
          key: 'customer_name',
          text: '客户名称',
        },
        {
          key: 'company_name',
          text: '公司名称',
        },
        {
          key: 'project_number',
          text: '项目编号',
        },
        {
          key: 'project_name',
          text: '项目名称',
        },
        {
          key: 'bu_name',
          text: 'BO审批',
        },
        {
          key: 'initiator_name',
          text: '发起人',
        },
        {
          key: 'invoice_time',
          text: '开票日期',
        },
        {
          key: 'invoice_number',
          text: '发票号码',
        },
        {
          key: 'untaxed_amount',
          text: '未税开票金额',
        },
        {
          key: 'total',
          text: '含税开票金额',
        },
        {
          key: 'total_received_amount',
          text: '已回款金额',
        },
        {
          key: 'unreceived_amount',
          text: '未回款金额',
        },
        {
          key: 'received_payment_status',
          text: '回款状态',
        },
        {
          key: 'received_payment_time',
          text: '回款日期',
        },
        {
          key: 'received_amount',
          text: '回款金额',
        },
        {
          key: 'received_payment_desc',
          text: '回款备注',
        },
        {
          key: 'do_number',
          text: 'DO/PO单号',
        },

        {
          key: 'desc',
          text: '申请描述',
        },
        {
          key: 'created_at',
          text: '创建时间',
        },
        {
          key: 'updated_at',
          text: '更新时间',
        },
      ],
      dialogType: null,
      title: null,
      receivedSummary: [],
      summaryVisible: false,
      titlePrefix: '开票申请 - '
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
  },
  created () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getProjectTable', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getReceivedPaymentTable', params)
    },
    sortChange (column, prop, order) {
      this.search.sort_by_id = this.search.sort_by_received_payment_time = null
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'id') {
        this.search.sort_by_id = sortBy
      } else if (column.prop === 'received_payment_time') {
        this.search.sort_by_received_payment_time = sortBy
      }
      this.onSearch()
    },
    getExportData (params) {
      return request.page('exportReceivedPayment', params)
    },
    onExportPage () {
      this.$export(`${this.$route.name}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.name, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        this.options.received_payment_status.forEach((status) => {
          if (status.value === row.received_payment_status) {
            row.received_payment_status = status.label
          }
        })
      })
      return data
    },
    customerRemoteMethod (query) {
      return request.common('getCustomerTable', {keyword: query.name, type: [10, 70]})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.search.customerid})
    },
    customerLabel (item) {
      return item.name + '/' + item.number
    },
    projectRemoteMethod (query) {
      return request.common('getProjectTable', {keyword: query.name})
    },
    getProjectInfoRemote () {
      return request.common('getProjectDetail', {id: this.search.projectid})
    },
    async openReceivedSummaryDialog () {
      this.receivedSummary = []
      await request.common('getReceivedSummary', removeEmptyParams(this.search)).then((data) => {
        let totalTaxedAmount = 0
        let totalReceivedAmount = 0
        let totalUnreceivedAmount = 0
        for (const i in data.data) {
          if (data.data.hasOwnProperty(i)) {
            totalTaxedAmount += data.data[i].total
            totalReceivedAmount += data.data[i].received_amount
            totalUnreceivedAmount += data.data[i].unreceived_amount
            this.receivedSummary.push(data.data[i])
          }
        }
        if (totalTaxedAmount) {
          this.receivedSummary.push({
            'status': -1, // -1 为 总计 列，需单独处理显示文字
            'total': totalTaxedAmount,
            'received_amount': totalReceivedAmount,
            'unreceived_amount': totalUnreceivedAmount,
          })
        }
        this.title = '回款统计'
        this.summaryVisible = true
      })
    },
    adminuserRemoteMethod (query) {
      return request.common('getPlatformUsersIndex', query)
    },
    getAdminUserInfoRemote () {
      return request.common('getPlatformUsersDetail', {id: this.search.bu_approver})
    },
    openDetail (id) {
      this.$router.push(`/invoice-apply/detail/${id}?type=detail`)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/ReceivedPaymentTable.vue